// extracted by mini-css-extract-plugin
export default {"about_desc":"AboutSection_about_desc__b+LHe","animate_box":"AboutSection_animate_box__DHGuw"};